<script>
  import {
    encodingToHex,
    encode,
    decode,
    hexToEncoding,
    createEmptyEncoding,
  } from "bitframes";
  import StaticArtwork from "./StaticArtwork.svelte";
  import { fetchReceipt, fetchTokenDetails } from "../util/data-fetcher";
  import { createEventDispatcher, getContext, onMount } from "svelte";
  import Info from "../icons/info.svelte";
  import ExternalLink from "./ExternalLink.svelte";
  import UserLink from "./UserLink.svelte";
  import { predictDate } from "../util/estimateBlockDate.js";
  import RoundLinkButton from "./RoundLinkButton.svelte";
  import {
    CONTRACT_NETWORK,
    CONTRACTS,
    createEtherscanLink,
    getBlockWeek,
    LINK_CREATE,
    LINK_CREATE_EDITION,
  } from "../util/constants";
  import EncodingHex from "./EncodingHex.svelte";
  import { windowState } from "../util/window-state";
  import External from "../icons/external.svelte";
  import InlineSpan from "./InlineSpan.svelte";
  import Button from "./Button.svelte";

  export let system = 0x00;
  export let encoding = null;
  export let index = -1;
  // export let publisher = null;
  // export let blockNumber = null;

  function getContractAddress() {
    return system == 0x00
      ? CONTRACTS.NFT_OPEN.address
      : CONTRACTS.NFT_LIMITED.address;
  }

  const dispatcher = createEventDispatcher();
  const EMPTY_ENCODING = createEmptyEncoding({ system });

  let loading = true;
  let info;
  let reveal, refresh;

  const params = new URLSearchParams(window.location.search);
  reveal = params.get("reveal");
  refresh = params.get("refresh");

  if (reveal) {
    params.delete("reveal");
    if (params.has("refresh")) params.delete("refresh");
    const search =
      [...params.keys()].length == 0 ? "" : `?${params.toString()}`;
    window.history.replaceState(null, "", window.location.pathname + search);
  }

  const toast = getContext("toast");

  const gallery = getContext("gallery");
  // let stats;
  let _lastIndex;
  $: {
    if (_lastIndex !== index) {
      _lastIndex = index;
      grab();
    }
  }

  let encodingHex, encodingBytes;
  let _lastHex;
  $: {
    if (encoding) {
      encodingHex =
        typeof encoding === "string" ? encoding : encodingToHex(encoding);
      encodingBytes =
        typeof encoding === "string" ? hexToEncoding(encoding) : encoding;
    } else {
      encodingHex = encodingBytes = null;
    }
    if (encodingHex !== _lastHex) {
      _lastHex = encodingHex;
      // stats = null;
      // if (encodingBytes) {
      //   try {
      //     // stats = renderStats({ encoding: encodingBytes });
      //   } catch (err) {}
      // }
    }
  }

  onMount(() => {});

  async function grab() {
    loading = true;
    info = null;

    // console.log("IS REFRESH", refresh, index);
    if (reveal && refresh && index >= 0) {
      let refreshSeed;
      try {
        // 0100c07f38d2004187ab285f90957486a0b3e4f149b6384ca7304f1b87e943c7

        refreshSeed = encodingToHex(encode(decode(hexToEncoding(refresh))));
        const opts = {
          token_id: index,
          contract: getContractAddress(),
        };
        // fetchTokenDetails.clearCache(opts);
        const fullInfo = await fetchTokenDetails(opts);
        info = {
          ...fullInfo,
          seed: refreshSeed,
          // token_id: firstToken.token_id,
          // published_address: null,
          // published_tx_hash: res.tx_hash,
          // published_block_number: res.block_number,
          // owned_address: null,
          // owned_tx_hash: res.tx_hash,
          // owned_block_number: res.block_number,
        };
      } catch (err) {
        console.error(err);
        console.warn("invalid refresh param");
      }
    } else if (reveal) {
      const res = await fetchReceipt({ tx_hash: reveal });
      // const tokens = res && res.contracts ? res.contrac
      let tokens;
      if (res && res.contracts) {
        const d = res.contracts[getContractAddress()];
        if (d && d.tokens) tokens = d.tokens;
      }
      if (tokens) {
        const token = tokens.find((f) => f.minted);
        if (token) {
          info = {
            seed: token.seed,
            token_id: token.token_id,
            published_address: token.published_address,
            published_tx_hash: res.tx_hash,
            published_block_number: res.block_number,
            owned_address: token.owned_address,
            owned_tx_hash: res.tx_hash,
            owned_block_number: res.block_number,
          };
        }
      }
      reveal = null;
      refresh = null;
    } else {
      info = await fetchTokenDetails({
        token_id: index,
        contract: getContractAddress(),
      });
    }
    if (!info || info.token_id == null) {
      info = null;
      toast.error("Could not find token - may still be indexing");
      console.error("Should show error: info did not respond");
    } else {
      index = info.token_id;
      encoding = info.seed;
      gallery.address.update(() => info.published_address);
    }
    loading = false;
  }

  function timeDisplay(date) {
    const month = date.getUTCMonth() + 1; // Months start at 0!
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();
    return `${year}/${String(month).padStart(2, "0")}/${String(day).padStart(2, "0")}`;
    // const date.getHours(),
    // date.getMinutes(),
    // date.getSeconds()
  }
</script>

<div class="container">
  <div class="artwork-panel">
    <!-- {#if encodingBytes} -->
    <StaticArtwork
      allowClickZoom={$windowState.width > 750}
      allowTouchZoom={true}
      encoding={encodingBytes || EMPTY_ENCODING}
      autoCanvasResolution
      hotkeys={false}
      hd={true}
      displayPadding={20}
    />
    <!-- {/if} -->
  </div>
  <div class="detail-panel">
    {#if true}
      <div class="detail-frame">
        <div class="row noselect">
          <div class="header">System</div>
          <div class="detail">
            {#if encodingBytes}
              {encodingBytes[0] == 0x00 ? "OPEN EDITION" : "32 BIT EDITION"}
            {:else}
              ..
            {/if}
          </div>
        </div>
        <div class="row noselect">
          <div class="header">Network</div>
          <div class="detail">
            {#if CONTRACT_NETWORK == "sepolia"}ETHEREUM SEPOLIA (TESTNET){:else}ETHEREUM
              MAINNET{/if}
          </div>
        </div>
        <div class="row noselect">
          <div class="header">Token ID</div>
          <div class="detail">#{index == -1 ? "..." : index}</div>
        </div>
        <div class="row">
          <div class="header noselect">Encoding</div>
          <div class="detail">
            {#if encodingHex}
              <EncodingHex {encodingHex} />
            {:else}
              ..
            {/if}
          </div>
        </div>

        <div class="row noselect">
          <div class="header">Minted By</div>
          <div class="detail">
            {#if info}
              <UserLink resolve address={info.published_address} />
            {:else}
              ..
            {/if}
          </div>
        </div>
        <div class="row noselect">
          <div class="header">Minted On</div>
          <div class="detail">
            {#if info}
              <ExternalLink
                href={createEtherscanLink({
                  type: "tx",
                  fragment: info.published_tx_hash,
                })}
              >
                {timeDisplay(
                  predictDate(info.published_block_number, CONTRACT_NETWORK)
                )}
              </ExternalLink>
              <div class="block-number">
                week {getBlockWeek(info.published_block_number)}
              </div>
            {:else}
              ..
            {/if}
          </div>
        </div>

        {#if info && info.published_address !== info.owned_address}
          <div class="row noselect">
            <div class="header">Current Owner</div>
            <div class="detail">
              <UserLink resolve address={info.owned_address} />
            </div>
          </div>
          <div class="row noselect">
            <div class="header">Last Transfer</div>
            <div class="detail">
              <ExternalLink
                href={createEtherscanLink({
                  type: "tx",
                  fragment: info.owned_tx_hash,
                })}
              >
                {timeDisplay(
                  predictDate(info.owned_block_number, CONTRACT_NETWORK)
                )}
              </ExternalLink>
              <!-- <div class="block-number">
                block {info.owned_block_number}
              </div> -->
            </div>
          </div>
        {/if}
      </div>
    {/if}
    {#if system == 0x01 && index >= 0}
      <div class="system-01-refresh">
        <!-- <Button publish text="Update" on:click={() => {}} /> -->
        <RoundLinkButton
          on:click={(ev) => {
            if (encodingBytes && system == 0x01 && encodingBytes[0] == 0x00) {
              dispatcher("encodingChanged", { encoding: encodingBytes });
            }
          }}
          bigger
          text="EDIT ENCODING"
          href={`/${LINK_CREATE_EDITION}/${index}`}
        ></RoundLinkButton>
      </div>
      <div class="system-01-mutable">
        <div class="info-icon"><Info></Info></div>
        <div class="info-text">
          <em
            >Only the owner of this edition can publish a new encoding and
            design on-chain. This action can also be performed in a
            decentralized manner <InlineSpan
              ><ExternalLink
                href="https://etherscan.io/address/0x642fEd40AeD8e7A7CF7c4CFf77F2529a4348ccC3#writeProxyContract#F4"
                >via the contract</ExternalLink
              >.</InlineSpan
            ></em
          >
        </div>
      </div>
    {/if}
  </div>
</div>

<style>
  .container {
    /* height: 100vh; */
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    flex-shrink: 0;
    /* overflow: hidden; */
    display: flex;
    justify-content: stretch;
    align-items: flex-start;
    flex-direction: row;
    flex-grow: 1;
    flex-shrink: 0;
  }

  .artwork-panel {
    /* max-height: 85vh; */
    touch-action: manipulation;
    /* background: pink; */
    height: 100%;
    width: 60%;
    box-sizing: border-box;
    justify-content: stretch;
    align-items: stretch;
    flex-grow: 1;
    flex-shrink: 0;
    display: flex;
  }

  .detail-panel {
    height: 100%;
    /* overflow: hidden; */
    border-left: 1px solid black;
    width: 40%;
    flex-grow: 1;
    flex-shrink: 1;
    margin: 0;
    box-sizing: border-box;
    padding: 20px;
  }

  .block-number {
    font-size: 12px;
    text-transform: uppercase;
  }
  .row {
    padding: 10px 10px;
    border-bottom: 1px solid black;
  }
  .row:last-child {
    border-bottom: 0;
  }

  .header {
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 400;
    text-transform: uppercase;
  }

  .detail {
    display: flex;
    flex-direction: row;
    width: 100%;
    box-sizing: border-box;
    gap: 10px;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
  }

  .detail-frame {
    --border-color: black;
    border: 1px solid black;
    box-shadow:
      0px 3px 0px var(--border-color),
      3px 0px 0px var(--border-color),
      3px 3px 0px var(--border-color);
  }

  .system-01-mutable {
    margin-top: 20px;
    max-width: 500px;
    display: flex;
    justify-content: flex-start;
    /* align-items: center; */
    font-size: 10px;
  }
  .system-01-refresh {
    margin-top: 20px;
    max-width: 500px;
    display: flex;
    justify-content: flex-start;
    /* align-items: center; */
    font-size: 10px;
  }
  .info-icon {
    padding-right: 10px;
    margin-top: 0px;
    width: 18px;
    height: 18px;
    display: inline-flex;
  }

  @media screen and (max-width: 750px) {
    .container {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
    .artwork-panel {
      /* height: calc(max(550px, 100vmin)); */
      /* height: 500px; */
      /* min-height: 400px; */
      max-height: initial;
      height: 100vw;
      width: 100%;
    }
    .detail-panel {
      /* overflow-y: scroll; */
      width: 100%;
      border-left: none;
      border-top: 1px solid black;
      /* padding-bottom: 100px; */
    }
  }
</style>
